export default "__VITE_ASSET__10ac71d6__"